// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useReducer, useState} from 'react';
import cn from 'classnames';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import zutil from '/util/util.js';
import {Settings_context} from '../../settings_ctx';
import {Input} from '../../lib/input.js';
import {logout_sessions} from '../logout_sessions.js';
import {Button} from '../../lib/button';
import Eye_show from '../../img/hola2023/icons/16/eye_show.svg';
import Eye_hide from '../../img/hola2023/icons/16/eye_hide.svg';
import {Pass_meter_2023} from '../pass_meter';
import styles from './change_password_form.module.less';

interface i_change_password_props {
    title?: string | JSX.Element;
    email?: string;
    on_success?: ()=>void;
    input_tag?: React.FC<any>;
    button_tag?: React.FC<any>;
    pass_meter_props?: object_of<any>;
}

interface i_msg {
    status: string | null;
    text?: string;
    src?: number;
}

const ERRORS = {
    too_short: 'New password must contain at least 8 characters',
    dont_match: 'Password does not match',
    pass_incorrect: 'Wrong current password',
    pass_weak: 'Must contain at least: 8 characters, one number, one '
        +'uppercase',
};

const use_change_password = (props: i_change_password_props = {})=>{
    const {on_success, email} = props;
    const [pass, set_pass] = useState('');
    const [pass_new, set_pass_new] = useState('');
    const [pass_re, set_pass_re] = useState('');
    const [msg, set_msg] = useState<i_msg>({status: null, text: ''});
    const on_change = (type?: string)=>(value: string)=>{
        if (msg.status)
            set_msg({status: null});
        switch (type)
        {
            case 'new': set_pass_new(value); break;
            case 're': set_pass_re(value); break;
            default: set_pass(value);
        }
    };
    const on_submit = event=>{
        event.preventDefault();
        etask(function*(){
            try {
                if (pass_new.length < 8)
                {
                    return void set_msg({status: 'error', src: 2, text:
                        ERRORS.too_short});
                }
                if (pass_new!=pass_re)
                {
                    return void set_msg({status: 'error', src: 3, text:
                        ERRORS.dont_match});
                }
                yield fetch('/users/change_password', {
                    method: 'POST',
                    body: {
                      password: pass,
                      new_pass: pass_new,
                      service: true,
                    },
                });
                yield logout_sessions();
                on_success && on_success();
            } catch(e){
                const status = e.status || e.hola_info?.status;
                const txt = zutil.get(e, 'hola_info.response_text', '');
                const text = status==403 ? ERRORS.pass_incorrect :
                    txt.indexOf('Previous') == 0 ? txt : ERRORS.pass_weak;
                set_msg({status: 'error', text, src: status==403 ? 1 : 2});
            }
        });
    };
    const disabled = !(pass && pass_new && pass_re);
    return {pass, pass_new, pass_re, msg, disabled, on_change, on_submit,
        email};
};

const pass_st_messages = {
    'weak': 'Weak',
    'medium': 'Medium',
    'good': 'Good',
    'perfect': 'Strong',
};

interface i_show_pass {
    pass: boolean;
    pass_new: boolean;
    pass_re: boolean;
}
const show_icon = <Eye_show className={styles.show_icon}/>;
const hide_icon = <Eye_hide className={styles.hide_icon}/>;
const get_pass_type = v=>v ? 'text' : 'password';
const get_icon = v=>v ? show_icon : hide_icon;
export const Change_password_form = (props: i_change_password_props)=>{
    const {theme} = useContext(Settings_context);
    const {pass, pass_new, pass_re, msg, disabled, on_change,
        on_submit, email} = use_change_password(props);
    const [show, dispatch] = useReducer((state: i_show_pass, action: string)=>{
        return {...state, [action]: !state[action]};
    }, {pass: false, pass_new: false, pass_re: false});
    return <form role="form" onSubmit={on_submit} className={styles.form}>
      <p className={cn(theme.bold, styles.title)}>Change password</p>
      <Input type={get_pass_type(show.pass)} value={pass}
        on_change={on_change()}
        name="curret_password" placeholder="Enter your password"
        label="Old password" error={msg.src==1 && msg.text}
        icon={<div className={styles.eye} onClick={()=>dispatch('pass')}>
          {get_icon(show.pass)}
        </div>}
      />
      <div className={styles.new_pass_field}>
        <Input type={get_pass_type(show.pass_new)} value={pass_new}
          on_change={on_change('new')}
          name="password" placeholder="Enter new password"
          label="New password" error={msg.src==2 && msg.text}
          icon={<div className={styles.eye} onClick={()=>dispatch('pass_new')}>
            {get_icon(show.pass_new)}
          </div>}
        />
        <div className={cn(styles.pass_meter,
          msg.src==2 && styles.hidden, !pass_new && styles.up)}>
          <Pass_meter_2023 pass={pass_new} email={email} bars
            messages={pass_st_messages}/>
        </div>
      </div>
      <Input type={get_pass_type(show.pass_re)} value={pass_re}
        on_change={on_change('re')}
        name="password_confirm" placeholder="Enter new password"
        label="Repeat new password" error={msg.src==3 && msg.text}
        icon={<div className={styles.eye} onClick={()=>dispatch('pass_re')}>
          {get_icon(show.pass_re)}
        </div>}
      />
      <Button cls={styles.submit} color="black2023" disabled={disabled}
        caption="Set new password" inline size="md" />
    </form>;
};

export const Change_password_form_new = (props: i_change_password_props)=>{
    const {theme} = useContext(Settings_context);
    const {pass, pass_new, pass_re, msg, disabled, on_change,
        on_submit, email} = use_change_password(props);
    const [show, dispatch] = useReducer((state: i_show_pass, action: string)=>{
        return {...state, [action]: !state[action]};
    }, {pass: false, pass_new: false, pass_re: false});
    const [focused_input, set_focused_input] = useState(null);
    const [show_strength, set_show_strength] = useState(false);
    const handle_focus = input_name=>{
        set_focused_input(input_name);
    };
    const handle_blur =()=>{
        set_focused_input(null);
    };
    const handle_change = type=>value=>{
        on_change(type)(value);
        if (type == 'new' && value.length>0)
            set_show_strength(true);
        else if (type == 'new' && value.length == 0)
            set_show_strength(false);
    };
    const Input_tag = props.input_tag || Input;
    const Button_tag = props.button_tag || Button;
    return <form role="form" onSubmit={on_submit} className={cn(styles.form,
      styles.new)}>
        {props.title || <p className={cn(theme.p18, styles.title)}>
          Change password</p>}
        <div className={cn(styles.input_wrapper,
          focused_input == 'old_password' && styles.focused)}>
        <Input_tag type={get_pass_type(show.pass)} value={pass}
          on_change={handle_change('')}
          name="curret_password" placeholder="Enter old password"
          label="Old password" error={msg.src==1 && msg.text}
          icon={<div className={styles.eye} onClick={()=>dispatch('pass')}>
          {get_icon(show.pass)}
          </div>}
          on_focus={()=>handle_focus('old_password')}
          on_blur={handle_blur}
        />
        </div>
        <div className={styles.new_pass_field}>
          <div className={cn(styles.input_wrapper,
            focused_input == 'new_password' && styles.focused)}>
              <Input_tag type={get_pass_type(show.pass_new)} value={pass_new}
                on_change={handle_change('new')}
                name="password" placeholder="Enter new password"
                label="New password" error={msg.src==2 && msg.text}
                icon={<div className={styles.eye}
                onClick={()=>dispatch('pass_new')}>
                  {get_icon(show.pass_new)}
                </div>}
                on_focus={()=>handle_focus('new_password')}
                on_blur={handle_blur}
                />
          </div>
          <div className={cn(styles.pass_meter,
            msg.src==2 && styles.hidden, !pass_new && styles.up)}
            data-elem={'pass_meter'}>
            <Pass_meter_2023
              pass={pass_new}
              email={email}
              bars
              messages={pass_st_messages}
              show_messages={show_strength}
              show_requirements={pass_new.length == 0}
              {...props.pass_meter_props}
            />
          </div>
        </div>
        <div className={cn(styles.input_wrapper,
          focused_input == 'repeat_password' && styles.focused)}>
          <Input_tag type={get_pass_type(show.pass_re)} value={pass_re}
            on_change={handle_change('re')}
            name="password_confirm" placeholder="Enter new password"
            label="Repeat new password" error={msg.src==3 && msg.text}
            icon={<div className={styles.eye}
              onClick={()=>dispatch('pass_re')}>
              {get_icon(show.pass_re)}
            </div>}
            on_focus={()=>handle_focus('repeat_password')}
            on_blur={handle_blur}
          />
        </div>
        <Button_tag cls={styles.submit_toolip} disabled={disabled}
          caption="Set new password" inline size={'lg'} round={false} />
    </form>;
};
